import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { Immutable } from 'immer';
import { DateTime } from 'luxon';
import { MessageType, TimePeriod } from '../components/TrackerManager/constants';
import type { ManagedTracker, ShippingInfo } from '../store/trackers/trackers_reducers';

const timePeriodMinutesToMillis = (timePeriod: TimePeriod): number => {
  switch (timePeriod) {
    case TimePeriod.lastFiveMinutes:
      return 5 * OneMinuteInMillis;
    case TimePeriod.lastTenMinutes:
      return 10 * OneMinuteInMillis;
    case TimePeriod.lastOneHour:
      return 60 * OneMinuteInMillis;
    default:
      throw new Error('Unsupported TimePeriod');
  }
};

const isOlderThan = (date: Date | undefined, timePeriod: TimePeriod): boolean =>
  date
    ? DateTime.fromJSDate(date) < DateTime.now().minus(timePeriodMinutesToMillis(timePeriod))
    : true;

export const isShippable = (
  tracker: Immutable<ManagedTracker>,
  shippingInfo: Immutable<ShippingInfo>,
): boolean => {
  if (isOlderThan(tracker.state.lastConnectedAt, shippingInfo.lastConnectedAtTimePeriod)) {
    return false;
  }

  if (isOlderThan(tracker.state.lastDataAt, shippingInfo.lastDataAtTimePeriod)) {
    return false;
  }

  if (tracker.state.battery == null || tracker.state.battery < shippingInfo.minBattery) {
    return false;
  }

  if (
    shippingInfo.invalidMessageTypes.includes(MessageType.Pending) &&
    tracker.messagesCounts?.pendingCount !== 0
  ) {
    return false;
  }

  if (
    shippingInfo.invalidMessageTypes.includes(MessageType.Error) &&
    tracker.messagesCounts?.errorCount !== 0
  ) {
    return false;
  }

  if (
    shippingInfo.invalidMessageTypes.includes(MessageType.Scheduled) &&
    tracker.messagesCounts?.scheduledCount !== 0
  ) {
    return false;
  }

  return true;
};
